// extracted by mini-css-extract-plugin
module.exports = {"title":"global-error_styles_title__n9FWB","alertSection":"global-error_styles_alertSection__aKH8_"};